import { newStepValue } from '../../../../services/flowBuilder/utils/constants';

const regex = ['latitude', 'longitude'];

const locationOutbound = {
  json: {
    menu: {
      menuType: 'location',
      name: '',
      bodyText: '',
      menuParams: {
        direction: 'outbound',
        locationName: '',
        locationLatitude: '',
        locationLongitude: '',
        locationAddress: '',
      },
    },
    type: 'menu',
    next: newStepValue,
    metadata: {},
  },
  paths: [
    'menu.menuParams.direction',
    'menu.name',
    'menu.bodyText',
    'menu.menuParams.locationLatitude',
    'menu.menuParams.locationLongitude',
    'menu.menuParams.locationName',
    'menu.menuParams.locationAddress',
    'next',
  ],
  groups: [
    {
      Parameters: [
        'menu.menuParams.direction',
        'menu.name',
        'menu.bodyText',
        'menu.menuParams.locationLatitude',
        'menu.menuParams.locationLongitude',
        'menu.menuParams.locationName',
        'menu.menuParams.locationAddress',
      ],
    },
    {
      Logic: ['next'],
    }
  ],
};

const locationInbound = {
  json: {
    menu: {
      menuType: 'location',
      text: '',
      name: '',
      menuParams: {
        direction: 'inbound',
        header: '',
      },
    },
    type: 'menu',
    next: newStepValue,
    metadata: {},
  },
  paths: ['menu.menuParams.direction', 'menu.name', 'menu.menuParams.header', 'menu.text', 'next'],
  groups: [
    {
      Parameters: ['menu.menuParams.direction', 'menu.name', 'menu.menuParams.header', 'menu.text'],
    },
    {
      Logic: ['next'],
    },
  ],
};

export const location = {
  json: {
    menu: {
      menuType: 'location',
      description: '',
      locationDirection: '',
      text: '',
      name: '',
      menuParams: {
        direction: 'inbound',
        header: '',
        locationName: '',
        locationLatitude: '',
        locationLongitude: '',
        locationAddress: '',
      },
    },
    type: 'menu',
    next: newStepValue,
    metadata: {},
  },

  paths: [
    'menu.locationDirection',
    'menu.menuParams.direction',
    'menu.name',
    'menu.menuParams.header',
    'menu.text',
    'menu.bodyText',
    'menu.menuParams.locationLatitude',
    'menu.menuParams.locationLongitude',
    'menu.menuParams.locationAddress',
    'menu.menuParams.locationName',
    'next',
  ],
  groups: [
    {
      Parameters: [
        'menu.locationDirection',
        'menu.menuParams.direction',
        'menu.name',
        'menu.menuParams.header',
        'menu.text',
        'menu.bodyText',
        'menu.menuParams.locationLatitude',
        'menu.menuParams.locationLongitude',
        'menu.menuParams.locationAddress',
        'menu.menuParams.locationName',
      ],
    },
    {
      Logic: ['next'],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
      },
    },
    header: {
      type: 'text',
      label: 'Header',
      validators: {
        required: false,
      },
      attributes:{
        optional: true,
      }
    },
    text: {
      type: 'textarea',
      label: 'Text',
      validators: {
        required: true,
      },
    },
    bodyText: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    direction: {
      type: 'selector',
      label: 'Location Direction',
      attributes: {
        options: {
          inbound: 'Inbound',
          outbound: 'Outbound',
        },
        data: true,
      },
      validators: {
        required: true,
        optionSelected: true,
      },
    },
    locationAddress: {
      type: 'text',
      label: 'Location Address',
      validators: {
        required: true,
      },
    },
    locationName: {
      type: 'text',
      label: 'Location Name',
      validators: {
        required: true,
      },
    },
    locationLatitude: {
      type: 'text',
      label: 'Latitude',
      placeholder: 'E.g. -33.8811',
      validators: {
        required: true,
        latitudeCheck: true,
      },
    },
    locationLongitude: {
      type: 'text',
      label: 'Longitude',
      placeholder: 'E.g. 18.63561',
      validators: {
        required: true,
        longitudeCheck: true,
      },
    },
    next: {
      type: 'next',
      label: 'Point to',
      validators: {
        optionSelected: true,
      },
    },
  },
  data: {
    dataPath: 'menu.menuParams.direction',
    direction: {
      inbound: locationInbound,
      outbound: locationOutbound,
    },
  },
};
